import { render, staticRenderFns } from "./specialtyValuation.vue?vue&type=template&id=fb3ae9ac&scoped=true"
import script from "./specialtyValuation.vue?vue&type=script&lang=js"
export * from "./specialtyValuation.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/reportValuation/professionReportNew.css?vue&type=style&index=0&id=fb3ae9ac&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ae9ac",
  null
  
)

export default component.exports